import FlowGrid from '@/components/FlowGrid';
import Banner from '@/components/Banner2';
import Cases from '@/components/Cases';
import SmartCard from '@/components/SmartCard';
import SmartTitle from '@/components/SmartTitle';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    FlowGrid,
    Banner,
    Cases,
    SmartCard,
    SmartTitle,
    Appointment2
  },
  data() {
    return {
      bannerUrl: require('@/assets/images/service/online-support/onlineSupport-banner.png'),
      effectives: [{
        title: '全渠道覆盖',
        desc: '支持APP 、官网 、微信公众号、支付宝等全渠道接入客户',
        icon: require('@/assets/images/service/online-support/qudao.png')
      }, {
        title: '智能分配',
        desc: '对接客户信息智能分配，提升用户满意度',
        icon: require('@/assets/images/service/online-support/fenpei.png')
      }, {
        title: '全流程监控',
        desc: '全面数据报表统计和实时监控，服务过程全掌控',
        icon: require('@/assets/images/service/online-support/liucheng.png')
      }, {
        title: '智能辅助',
        desc: '辅助机器人进行客户消息预知、提供快捷回复，提升40%效率',
        icon: require('@/assets/images/service/online-support/fuzhu.png')
      }],
      skills: [{
        items: [{
          title: '客户智能分配',
          desc: '智能识别客户，将不同来源客户，根据来源渠道、工作负荷、熟客优先等机制智能分配给相应客服'
        }, {
          title: '回复方式丰富',
          desc: '支持文字、表情、图片、语音、视频、文件消息回复'
        }]
      }, {
        items: [{
          title: '服务过程监控',
          desc: '服务数据报表统计和实时监控，服务过程全掌控坐席、机器人服务过程实时监控，保证服务质量'
        }, {
          title: '支持断线重连',
          desc: '支持断线智能快速重连机制，保证消息收发'
        }]
      }, {
        items: [{
          title: '接待服务高效',
          desc: '服务过程中，辅助机器人、客户消息预知、快捷回复、客户消息提醒，辅助客服快速响应客户，提升效率'
        }, {
          title: '企业工单中心',
          desc: '工单无缝流转，按工单创建时间、工单标题、优先级、处理状态等多维度检索条件查询工单'
        }]
      }]
    };
  }
};